import React, { useState, useContext } from 'react';

import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import { Grid, CircularProgress } from '@material-ui/core';
import { Context as AuthContext } from '../../../contexts/authContext';
import { IllustrationLayout } from '../../layout/IllustrationLayout';
import bgImage from '../../../assets/images/illustrations/illustration-reset.jpg';
import { MDBox } from '../../MDBox';
import { MDInput } from '../../MDInput';
import { MDTypography } from '../../MDTypography';
import { MDButton } from '../../MDButton';

export default function ForgotPasswordForm() {
  const [email, setEmail] = useState('');
  const [isEmailSent, setIsEmailSent] = useState(false);
  const { sendEmailToResetPassword, isLoading, errors, clearState } =
    useContext(AuthContext);

  const sendEmail = async () => {
    if (sendEmailToResetPassword) {
      const isSent = await sendEmailToResetPassword(email);
      if (isSent) {
        setIsEmailSent(true);
      }
    }
  };
  const onFocus = () => {
    if (clearState) {
      clearState();
    }
  };

  return (
    <IllustrationLayout
      title="Forgot Password"
      description="Please enter your email."
      illustration={bgImage}
    >
      <MDBox component="form" role="form">
        <MDBox mb={2}>
          <MDInput
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={(errors && errors.email.length > 0) || undefined}
            helperText={errors && errors.email[0]}
            onFocus={onFocus}
            disabled={isEmailSent || undefined}
          />
        </MDBox>
        {isEmailSent && (
          <MDTypography color="info" variant="caption">
            Email is waiting for you in your inbox
          </MDTypography>
        )}
        <MDButton
          fullWidth
          variant="gradient"
          color="info"
          onClick={sendEmail}
          disabled={isLoading || isEmailSent}
        >
          {!isLoading ? 'Send email' : <CircularProgress color="inherit" />}
        </MDButton>
        <Grid container>
          <Grid item xs>
            <MDTypography variant="body2" color="info">
              <Link href="/" variant="body2">
                Sign in
              </Link>
            </MDTypography>
          </Grid>
          <Grid item>
            <MDTypography variant="body1" color="info">
              <Link href="/register" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </MDTypography>
          </Grid>
        </Grid>
        <Box mt={5}>
          <MDTypography variant="body2" color="info" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://www.fairfare.co/">
              FairFare
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
          </MDTypography>
        </Box>
      </MDBox>
    </IllustrationLayout>
  );
}
